import React from 'react'

export default function CopyrightNotice() {
  return (
    <div className="about-us">
      <h1>Copyright Notice</h1>
      <p>© [2025] WalkNow. All rights reserved.</p>

      <h2>1. Ownership</h2>
      <p>
        All content (text, design, graphics, software) belongs to WalkNow or its licensors.
      </p>

      <h2>2. Use</h2>
      <ul>
        <li>Personal and non-commercial use only</li>
        <li>Attribution required for sharing</li>
      </ul>

      <h2>3. Restrictions</h2>
      <ul>
        <li>No redistribution, sale, or modification without permission</li>
      </ul>

      <h2>4. User Content</h2>
      <p>
        Users retain rights but license WalkNow to use submitted content.
      </p>

      <h2>5. Infringement Notice</h2>
      <p>Email complaints to: <a href="mailto:ram1711sai@gmail.com">ram1711sai@gmail.com</a></p>

      <h2>6. Updates</h2>
      <p>Changes will be posted in this document.</p>

      <p>For any legal inquiries, contact <a href="mailto:ram1711sai@gmail.com">ram1711sai@gmail.com</a></p>
    </div>
  )
}
